import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import {Calendar, ArrowRight} from 'lucide-react'
import Newsletter from '../components/Newsletter'

const blogArticles = [
  {
    slug: 'glen-ivy-costco-guide-2025',
    title: 'How to find Glen Ivy Coupons at Costco (2025 Guide)',
    excerpt: 'Discover insider tips to maximize your savings at Costco when purchasing Glen Ivy Hot Springs gift cards and packages.',
    date: 'January 15, 2025',
    category: 'Costco Deals',
    gradient: 'from-green-400 to-blue-500'
  },
  {
    slug: 'glens-army-navy-free-shipping',
    title: "Glen's Army Navy Store: How to score free shipping",
    excerpt: 'Learn the secret tricks to getting free shipping every time you shop at Glen\'s Army Navy, plus exclusive discount codes.',
    date: 'January 10, 2025',
    category: 'Shopping Tips',
    gradient: 'from-blue-400 to-purple-500'
  },
  {
    slug: 'hidden-promo-codes-glencode',
    title: 'Hidden Promo Codes: The Glencode Official List',
    excerpt: 'Exclusive codes you won\'t find anywhere else. Our curated list of verified promo codes for all Glen-branded businesses.',
    date: 'January 5, 2025',
    category: 'Promo Codes',
    gradient: 'from-purple-400 to-pink-500'
  }
]

export default function BlogList() {
  useEffect(() => {
    document.title = 'Money-Saving Blog | Glen Ivy Coupons & Deal Guides | GlenCode'
    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Expert guides and tips for finding the best Glen Ivy coupons, Costco deals, and promo codes. Save money with our insider strategies.'
      )
    }
  }, [])

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-green-50 to-blue-50 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Money-Saving Tips & Guides
          </h1>
          <p className="text-xl text-gray-600">
            Expert advice on finding the best deals for Glen Ivy, Costco, and more
          </p>
        </div>
      </section>

      {/* Blog Articles */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-8">
            {blogArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/blog/${article.slug}`}
                className="block bg-white rounded-xl border-2 border-gray-200 overflow-hidden hover:border-green-300 hover:shadow-xl transition-all group"
              >
                <div className="md:flex">
                  <div className={`md:w-1/3 h-64 md:h-auto bg-gradient-to-br ${article.gradient}`}></div>
                  <div className="md:w-2/3 p-8">
                    <div className="flex items-center gap-4 mb-4">
                      <span className="px-3 py-1 bg-green-100 text-green-700 text-sm font-semibold rounded-full">
                        {article.category}
                      </span>
                      <div className="flex items-center gap-2 text-gray-500 text-sm">
                        <Calendar className="w-4 h-4" />
                        <span>{article.date}</span>
                      </div>
                    </div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-green-600 transition">
                      {article.title}
                    </h2>
                    <p className="text-gray-600 mb-4 leading-relaxed">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-2 text-green-600 font-semibold group-hover:gap-3 transition-all">
                      <span>Read More</span>
                      <ArrowRight className="w-5 h-5" />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Newsletter />
        </div>
      </section>
    </div>
  )
}
